module.exports = __webpack_public_path__ + "img/limited-time-award-5.b04e980f.png";